export { SelectedFacetTerms } from './SelectedFacetTerms';
